/* globals $ */
import { registerClass } from 'libs/ComponentLoader'
import Url from 'url-parse'

import './styles.scss'

class Account {
  constructor (element) {
    this.$el = $(element)

    // Profile Section
    this.switchActiveSection = this.switchActiveSection.bind(this)
    $(window).on('hashchange', this.switchActiveSection)
    this.switchActiveSection()
  }

  switchActiveSection () {
    const currentURL = new Url(window.location.href)

    if (this.$el.hasClass('account-profileHistory')) {
      let urlID
      let pagination = false

      if (currentURL.hash) {
        urlID = currentURL.hash
      } else if (currentURL.query.includes('page')) {
        pagination = true
      }

      if (urlID === '#orderHistory') {
        this.$el.addClass('account-history')
        this.$el.removeClass('account-profile')
      } else if (pagination === true) {
        this.adjustPaginationPath(currentURL)
        this.$el.addClass('account-history')
      } else {
        this.$el.addClass('account-profile')
        this.$el.removeClass('account-history')
      }
    }
  }

  adjustPaginationPath (currentURL) {
    const tagName = '#orderHistory'
    document.location.replace(`${currentURL.href}${tagName}`)
  }
}

registerClass('Account', Account)
